<template>
    <span class="text-primary">
        <i
            class="fa fa-download fa-lg icon-button mr-1"
            title="Download"
            @click.stop="downloadAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        },

        isPagamento: {
            type: Boolean,
            default: () => false
        }
    },

    methods: {
        downloadAnexo() {
            this.$store.dispatch('addRequest')

            let promisse
            if (!this.isPagamento) {
                promisse = this.dataServico.obterComprometimentoAnexo(
                    this.$route.params.codContrato,
                    this.anexo.idComprometimentoRequisicao,
                    this.anexo.comprometimentoAnexoId
                )
            } else {
                promisse = this.dataServico.obterComprometimentoAnexo(
                    this.anexo.idComprometimentoRequisicao,
                    this.anexo.comprometimentoAnexoId
                )
            }

            promisse.then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do anexo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.anexo.nomeArquivoOriginal)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
